import Logger from './../Logger';

/**
 * @param {string|Element} element
 * @return {Element}
 */
const domElement = function (element) {
    if (typeof element === 'string') {
        return document.querySelector(element);
    }
    if (typeof element === 'object' && element.nodeType > 0) {
        return element;
    }
    throw new TypeError(`Excepted argument "element" to be of type Element or string, got ${typeof element}`);
};

export default class OffCanvas {
    /**
     * Create a new Off-Canvas navigation
     *
     * @param {string|Element|null} showLeftButton
     * @param {string|Element|null} showRightButton
     * @param {string|Element|null} mainPage
     * @param {string|Element|null} container
     */
    constructor(showLeftButton, showRightButton, mainPage, container) {
        this._bindMethods();

        this._container = container ? domElement(container) : document.getElementsByTagName('html')[0];
        this._mainPage = domElement(mainPage);
        this._visiblePage = 'main';

        this._addEventListeners(
            showLeftButton ? domElement(showLeftButton) : null,
            showRightButton ? domElement(showRightButton) : null,
        domElement('.show-main-page')
        );
    }

    set visiblePage(newValue) {
        this.setVisiblePage(newValue);
    }

    get visiblePage() {
        return this.getVisiblePage();
    }

    /**
     * Returns the current visible page
     *
     * @returns {string}
     */
    getVisiblePage() {
        return this._visiblePage;
    }

    /**
     * Sets the visible page
     *
     * @param {string} page
     * @returns {OffCanvas}
     */
    setVisiblePage(page) {
        page = '' + page;

        const container = this._container;

        if (this._visiblePage === page) {
            Logger.log('[Iresults.OffCanvas] ' + 'Page did not change');

            return this;
        }

        this._visiblePage = page;
        switch (page) {
            case 'left':
            case 'navigation':
                Logger.log('[Iresults.OffCanvas] ' + 'Show mobile navigation');
                this._registerMainPageClick();

                container.classList.add('show-left-page');
                container.classList.remove('show-right-page');
                break;

            case 'right':
            case 'search':
                Logger.log('[Iresults.OffCanvas] ' + 'Show mobile search');
                this._registerMainPageClick();
                container.classList.add('show-right-page');
                container.classList.remove('show-left-page');
                break;

            default:
                Logger.log('[Iresults.OffCanvas] ' + 'Show main');
                this._unregisterMainPageClick();
                container.classList.remove('show-left-page');
                container.classList.remove('show-right-page');
        }

        return this;
    }

    /**
     * Show the left page
     *
     * @returns {OffCanvas}
     */
    showLeftPage() {
        this.visiblePage = 'left';

        return this;
    }

    /**
     * Show the right page
     *
     * @returns {OffCanvas}
     */
    showRightPage() {
        this.visiblePage = 'right';

        return this;
    }

    /**
     * Show the main page
     *
     * @returns {OffCanvas}
     */
    showMainPage() {
        this.visiblePage = 'main';

        return this;
    }

    /**
     * @private
     */
    _addEventListeners(showLeftButton, showRightButton, showMainButton) {
        if (showLeftButton) {
            Logger.debug('[Iresults.OffCanvas] ' + 'Add click event listener to showLeftButton', showLeftButton);
            showLeftButton.addEventListener('click', this._showLeftPageCallback);
        }
        if (showRightButton) {
            Logger.debug('[Iresults.OffCanvas] ' + 'Add click event listener to showRightButton', showRightButton);
            showRightButton.addEventListener('click', this._showRightPageCallback);
        }
        if (showMainButton) {
            Logger.debug('[Iresults.OffCanvas] ' + 'Add click event listener to showMainButton', showMainButton);
            showMainButton.addEventListener('click', this._showMainPageCallback);
        }
    }

    /**
     * @private
     */
    _registerMainPageClick() {
        this._mainPage.addEventListener('mousedown', this._showMainPageCallback);
    }

    /**
     * @private
     */
    _unregisterMainPageClick() {
        this._mainPage.removeEventListener('mousedown', this._showMainPageCallback);
    }

    /**
     * @private
     */
    _showLeftPageCallback(event) {
        Logger.debug('[Iresults.OffCanvas] ' + 'Show left page button clicked');
        event.stopPropagation();
        this.showLeftPage();
    }

    /**
     * @private
     */
    _showRightPageCallback(event) {
        Logger.debug('[Iresults.OffCanvas] ' + 'Show right page button clicked');
        event.stopPropagation();
        this.showRightPage();
    }

    /**
     * @private
     */
    _showMainPageCallback(event) {
        Logger.debug('[Iresults.OffCanvas] ' + 'Show main page button clicked');
        if (this.visiblePage !== 'main') {
            event.stopPropagation();
            this.showMainPage();
        }
    }

    /**
     * @private
     */
    _bindMethods() {
        this._showMainPageCallback = this._showMainPageCallback.bind(this);
        this._showLeftPageCallback = this._showLeftPageCallback.bind(this);
        this._showRightPageCallback = this._showRightPageCallback.bind(this);
    }
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/Ui/OffCanvas.js